import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { snakeToCamel } from '../components/AdminDashboard/AdminEditRelease'

const useAnalyticsStore = create(
    (set, get) => ({
      // Analytics data
      reports: [],
      sorting: [],
      releaseStats: [],
      balance: 0,
      
      // Processed data
      values: [],
      filteredValues: [],
      yearFilter: [],
      year: '',
      topPlatforms: [],
      topCountries: [],
      releasesList: [],
      topReleases: [],
      releases: [],
      platformsData: [],
      lastMonthRevenue: 0,
      hasData: false,
      
      // Helper functions
      getUniqueYears: (array) => {
        if (!array || array.length === 0) return [];
        const uniqueYears = new Set();
        array.forEach(entry => {
          if (entry && entry.monthYear) {
            const [month, year] = entry.monthYear.split('/');
            uniqueYears.add(year);
          }
        });
        return Array.from(uniqueYears).sort();
      },
      
      getFilteredByYear: (array, selectedYear) => {
        if (!array || array.length === 0 || !selectedYear) return [];
        
        // Filter by year and sort by month
        const filtered = array.filter(entry => {
          if (!entry || !entry.monthYear) return false;
          const [month, year] = entry.monthYear.split('/');
          return year === selectedYear;
        });
        
        // Sort by month (numerically)
        return filtered.sort((a, b) => {
          const [monthA] = a.monthYear.split('/');
          const [monthB] = b.monthYear.split('/');
          return parseInt(monthA) - parseInt(monthB);
        });
      },
      
      // Actions
      setAnalyticsData: (data) => {
        console.log(data, "recieved data");
        if (!data) return;
        
        try {
          console.log("data", data);
          // Process reports
          const processedReports = data.reports?.map(report => snakeToCamel(report)) || [];
          
          // Process sorting data
          const sorting = data.sorting
          console.log(sorting, "sorting")
          
          let platforms = [];
          let countries = [];
          let topReleasesList = [];
          
          if (sorting && sorting.length > 0 && sorting[0]) {
            // Process platforms
            if (sorting[0].channels) {
              platforms = sorting[0].channels.map(platform => ({
                ...snakeToCamel(platform),
                channel: platform.channel || platform.platform,
                totalRevenue: platform.totalRevenue || platform.revenue
              }));
            }
            
            // Process countries
            if (sorting[0].countries) {
               countries = sorting[0]?.countries?.map(country=> {
                return {
                  ...country,
                  
                  totalRevenue: country.revenue || country.totalRevenue,
                }
              })
             
            }
            
            // Process top releases
            if (sorting[0].releases) {
              topReleasesList = sorting[0].releases.map((release)=>{
                return {
                  ...release,
                  totalRevenue: release.revenue || release.totalRevenue
                }
              })
            }
          }
          
          // Process release stats
          const dbGroupedReleases = data.releaseStats?.map(release => snakeToCamel(release)) || [];
          
          // Process platforms data for chart
          let platformsChartData = [];
          
          if (sorting && sorting.length > 0 && sorting[0] && sorting[0].channels) {
            const platformsValues = sorting[0].channels.map(platform => {
              let platformName = platform.channel?.toLowerCase() || platform.platform?.toLowerCase();
    
              if (platformName === 'snapshat') platformName = 'Snap';
              else if (platformName === 'apple music / itunes' || platformName === 'itunes' || platformName === 'itunes match') platformName = 'Apple Music';
              else if (platformName.includes('facebook')) platformName = 'Facebook';
              else if (platformName.includes('amazon')) platformName = 'Amazon';
              else if (platformName.includes('tiktok')) platformName = 'TikTok';
              else if (platformName.includes('spotify')) platformName = 'Spotify';
              else platformName = platform.channel || platform.platform;
    
              return {
                value: (platform.totalRevenue || platform.revenue).toFixed(0),
                name: platformName
              };
            });
            
            let platformsObj = {};
            
            platformsValues.forEach(platform => {
              if (platformsObj[platform.name]) {
                platformsObj[platform.name] += platform.value * 1;
              } else {
                platformsObj[platform.name] = platform.value * 1;
              }
            });
            
            for (let platObj in platformsObj) {
              platformsChartData.push({
                name: platObj,
                value: platformsObj[platObj]
              });
            }
          }
          
          // Get years and filtered values
          const store = get();
          const years = store.getUniqueYears(processedReports);
          const selectedYear = years.length > 0 ? years[years.length - 1] : '';
          const filtered = store.getFilteredByYear(processedReports, selectedYear);
          
          // Last month revenue
          const lastMonthRev = processedReports.length > 0 ? 
            processedReports[processedReports.length - 1].totalPrice.toFixed(0) : 0;
          console.log(countries, "countries")
          // Store the raw data
          set({
            reports: data.reports || [],
            sorting: data.sorting || [],
            releaseStats: data.releaseStats || [],
            balance: data.balance !== undefined ? data.balance.toFixed(0) : 0,
            
            // Store the processed data
            values: processedReports,
            yearFilter: years,
            year: selectedYear,
            filteredValues: filtered,
            topPlatforms: platforms,
            topCountries: countries,
            topReleases: topReleasesList,
            releases: dbGroupedReleases,
            releasesList: dbGroupedReleases,
            platformsData: platformsChartData,
            lastMonthRevenue: lastMonthRev,
            hasData: true
          });
      
          
        } catch (error) {
          console.error('Error processing analytics data:', error);
        }
      },
      
      updateYearFilter: (selectedYear) => {
        const store = get();
        if (!selectedYear || selectedYear === store.year) return;
        
        const filtered = store.getFilteredByYear(store.values, selectedYear);
        
        set({
          year: selectedYear,
          filteredValues: filtered
        });
      }
    })
)

export default useAnalyticsStore
